module.exports = __webpack_public_path__ + "static/media/large_linee.f7019711.svg";